<div class="ori-page">
  <div class="ori-page__header">
    <s-ori-header
      [userAvatar]="user?.avatar"
      [userName]="userName"
      [userPosition]="user?.group?.name"
      [isAuthorized]="isAuthorized"
      (toggleNavigation)="navigationMenu.toggle()"
    ></s-ori-header>
  </div>
  <div class="ori-page__content">
    <mat-drawer-container class="ori-page__drawer-container" autosize>
      <mat-drawer #navigationMenu mode="side" class="ori-page__drawer">
        <s-ori-navigation-sidebar 
          class="ori-page__navigation-menu"
          [(sidebarClosingMode)]="sidebarClosingMode"
        ></s-ori-navigation-sidebar>

      </mat-drawer>
      <mat-drawer-content #drawerContent>
          <div class="ori-page__content-wrapper">
            <ng-content></ng-content>
          </div>
      </mat-drawer-content>
    </mat-drawer-container>
  </div>
  <div class="ori-page__footer">
    <s-ori-footer></s-ori-footer>
  </div>

  <ori-toasts></ori-toasts>
</div>
